import React from 'react';
import Box from '@mui/material/Box';

export type Props = {
    children: JSX.Element | JSX.Element[];
};

const StepWrapper = (props: Props) => {
    return (
        <Box
            sx={{
                paddingLeft: '2vw',
                paddingRight: '2vw',
                paddingTop: '2vh',
                paddingBottom: '2vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
                flexDirection: 'column',
            }}
        >
            {props.children}
        </Box>
    );
};

export default StepWrapper;
